<template>
    <div style="margin: 10px" class="balance-card-batch">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-input
                    v-model="formInline.batchNo"
                    placeholder="请输入卡批次">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-select style="width: 100%" filterable v-model="formInline.recipientUserId" placeholder="请选择领取人" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="item.USER_NAME"
                        :value="item.USER_ID">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select style="width: 100%" filterable v-model="formInline.outboundUserId" placeholder="请选择出库人" clearable>
                    <el-option
                        v-for="item in userList"
                        :key="item.USER_ID"
                        :label="item.USER_NAME"
                        :value="item.USER_ID">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="searchData">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: flex-end;margin-bottom: 10px">
            <template v-if="cardType==2">
                <el-upload
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    :action="''"
                    :http-request="uploadBalanceRecord"
                    :on-success="uploadSuccess">
                    <el-button size="small" type="primary">优惠券激活导入</el-button>
                </el-upload>
                <el-upload
                    style="margin:0 10px"
                    multiple
                    :with-credentials="true"
                    :show-file-list="false"
                    :action="''"
                    :http-request="uploadBalanceCard"
                    :on-success="uploadSuccess">
                    <el-button size="small" type="primary">白名单导入</el-button>
                </el-upload>
                <el-button type="primary" size="small" @click="downloadModule">查看模板</el-button>

            </template>
            <el-button v-else-if="cardType==1" size="small" type="danger" @click="addOutCardBatch">礼品卡出库</el-button>
        </div>
        <el-table :data="giftCardBatchList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
            <el-table-column prop="batchName" label="批次名称" fixed="left"></el-table-column>
            <el-table-column prop="start" label="卡序号" width="160">
                <template slot-scope="scope">
                    {{scope.row.start}}
                    <br/>~<br/>
                    {{scope.row.end}}
                </template>
            </el-table-column>
            <el-table-column prop="quantity" label="领取数量"></el-table-column>
            <el-table-column prop="recipientUserName" width="200" label="领取信息">
                <template slot-scope="scope">
                    领取人：{{scope.row.recipientUserName}}
<!--                    <br/>-->
<!--                    联系方式：{{scope.row.recipientContact}}-->
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="单卡售卖金额"></el-table-column>
            <el-table-column prop="outboundUserName" width="200" label="出库信息">
                <template slot-scope="scope">
                    出库人：{{scope.row.outboundUserName}}
                    <br/>
                    出库时间：{{scope.row.outboundTime}}
                </template>
            </el-table-column>
            <el-table-column prop="cardTypeName" label="卡类型"></el-table-column>
            <el-table-column prop="customerInfo" label="客户信息"></el-table-column>
            <el-table-column label="操作" fixed="right" width="120">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="handleBalanceCardOutList(scope.row)">明细</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formInline.currentPage"
                :page-sizes="GCONFIG.pageSizes"
                :page-size="formInline.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <!-- 出库记录 -->
        <el-drawer
            size="70%"
            title="明细"
            :visible.sync="outListVisible">
            <CardBalanceOut ref="outDrawer" :batchNo="currentBatchNo"/>
        </el-drawer>
        <!-- 出库记录 -->
        <el-drawer
            size="70%"
            title="新增出库"
            :visible.sync="newOutVisible">
            <template slot="title">
                <div style="display: flex;justify-content: space-between">
                    <div>新增出库</div>
                    <div>
                        <el-button type="danger" size="small" @click="submitOutCardBatch">提交出库</el-button>
                    </div>
                </div>
            </template>
            <div style="padding: 10px">
<!--                <el-card class="box-card">-->
                    <el-form style="margin-bottom: 10px" label-width="120px" :modal="outFormParam" >
                        <el-form-item label="卡起始号：" :rules="{required: true, message: '请输入卡起始号'}">
                            <el-input @change="handleOutChange" style="width: 100%" v-model="outFormParam.start" placeholder="请输入卡起始号"></el-input>
                        </el-form-item>
                        <el-form-item label="出库张数："  :rules="{required: true, message: '请输入出库张数'}">
                            <el-input-number @change="handleOutChange" style="width: 100%;text-align: left" v-model="outFormParam.quantity" :min="1" controls-position="right" placeholder="请输入出库张数"></el-input-number>
                        </el-form-item>
                        <el-form-item label="领取人：" :rules="{required: true, message: '请选择领取人'}">
                            <el-select style="width: 100%" filterable v-model="outFormParam.recipientUserId" placeholder="请选择" clearable>
                                <el-option
                                    v-for="item in userList"
                                    :key="item.USER_ID"
                                    :label="item.USER_NAME"
                                    :value="item.USER_ID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="用途：" :rules="{required: true, message: '请选择用途'}">
                            <el-radio-group v-model="outFormParam.purpose">
                                <el-radio :label="'普通销售'">普通销售</el-radio>
                                <el-radio :label="'招待客情'">招待客情</el-radio>
                                <el-radio :label="'样品'">样品</el-radio>
                                <el-radio :label="'推广出库'">推广出库</el-radio>
                                <el-radio :label="'作废'">作废</el-radio>
                            </el-radio-group>
                            <el-input v-if="outFormParam.purpose=='普通销售'" v-model="outFormParam.amount" style="width: 100%" placeholder="请填写单张卡的销售金额"></el-input>
                        </el-form-item>
                        <el-form-item label="客户信息：">
                            <el-input v-model="outFormParam.customerInfo" style="width: 100%" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="钉钉审批编号：">
                            <el-input v-model="outFormParam.auditId" style="width: 100%" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-form>

<!--                </el-card>-->
                <el-alert
                    title="卡明细"
                    :closable="false" show-icon
                    type="success">
                </el-alert>
                <el-table size="small" style="width: 100%" :data="cardFormParam.detailVoList" stripe border center  v-loading="loading">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="batchId" label="卡批次">
                        <template slot-scope="scope">
                            {{cardFormParam.batchName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="cardId" label="卡ID"></el-table-column>
                    <el-table-column prop="cardTypeName" label="卡类型" width="110"></el-table-column>
                    <el-table-column prop="amount" label="卡金额"></el-table-column>
                    <el-table-column prop="cardStateName" label="卡状态"></el-table-column>
                </el-table>
            </div>

        </el-drawer>
    </div>
</template>
<script>
//导入 HTTP请求方法
import {getBalanceCardOutData,getUserListForDropbox,getBalanceCardDetail,balanceCardOut,balanceCardModuleUpload,balanceCardInventoryUpload,balanceCardModuleDownload} from '@/api/api';
import CardBalanceOut from '@/components/card/CardOutList.vue'
export default {
    data() {
        return {
            giftCardBatchList: [],// 批次信息
            userList: [],
            loading: true,
            formInline: {
                platformId: 1,
                currentPage: 1,
                pageSize: 10,
                recordsTotal: 0
            },
            outFormParam: {},
            cardFormParam: {},
            currentBatchNo:'',
            outListVisible: false,
            newOutVisible: false,

        }
    },
    components: {CardBalanceOut},
    props: ['cardType'],
    //挂载时候执行
    mounted(){
        //初始化首页数据
        this.queryGiftCardBatch();
        this.initUserList();
    },

    methods: {
        queryGiftCardBatch() {
            this.loading = true;
            let param = this.formInline;
            param.cardType = this.cardType;
            console.log(22,param)
            getBalanceCardOutData(this.formInline).then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                    this.formInline.recordsTotal = res.data.value.total;
                    this.giftCardBatchList = res.data.value.list;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message||res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err)
                this.$message({
                    showClose: true,
                    message: err.message||err.data.message||'网络异常',
                    type: 'error'
                });
            });
        },
        searchData(){
            this.formInline.currentPage = 1
            this.queryGiftCardBatch()
        },

        initUserList() {
            getUserListForDropbox().then((res) => {
                this.loading = false;
                if (res.data.status == 200) {
                    this.userList = res.data.value
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message||res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err)
                this.$message({
                    showClose: true,
                    message: err.message||err.data.message||'网络异常',
                    type: 'error'
                });
            });
        },
        //查询
        addOutCardBatch() {
            this.outFormParam = {}
            this.cardFormParam = {}
            this.newOutVisible = true
        },
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.queryGiftCardBatch();
        },
        handleCurrentChange(val) {
            this.formInline.currentPage = val;
            this.queryGiftCardBatch();
        },
        //卡明细
        handleBalanceCardOutList(row){
            console.log(row)
            this.outListVisible = true
            this.currentBatchNo = row.recordId
            this.$nextTick(()=>{
                console.log(this.$refs.outDrawer)
                this.$refs.outDrawer.queryBalanceCardBatch()
            })

        },
        uploadBalanceRecord(file){
            console.log(file)
            const form = new FormData()
            form.append('file',file.file)
            balanceCardInventoryUpload(form).then(res=>{
                if (res.data.status == 200) {
                    this.$message({
                        showClose: true,
                        message: '导入成功',
                        type: 'success'
                    });
                    this.queryGiftCardBatch()

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message||res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            })
        },
        uploadBalanceCard(file){
            console.log(file)
            const form = new FormData()
            form.append('file',file.file)
            balanceCardModuleUpload(form).then(res=>{
                if (res.data.status == 200) {
                    this.$message({
                        showClose: true,
                        message: '导入成功',
                        type: 'success'
                    });
                    this.queryGiftCardBatch()

                } else {
                    this.$message({
                        showClose: true,
                        message: res.message||res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            })
        },
        uploadSuccess(res){
            if (res.status == 500) {
                this.$message({
                    showClose: true,
                    message: res.value,
                    type: 'error'
                });
            }
            if (res.status == 400) {
                this.$message({
                    showClose: true,
                    message: "请上传excel文件",
                    type: 'error'
                });
            }
            if (res.status == 200) {
                this.$message({
                    showClose: true,
                    message: res.value,
                    type: 'success'
                });
            }
        },
        downloadModule(){
            window.open(`${balanceCardModuleDownload}`)
        },
        handleOutChange(val){
            console.log(val,this.outFormParam)
            if(this.outFormParam.quantity&&this.outFormParam.start){
                this.getCardDetail()
            }
        },
        getCardDetail(){

            getBalanceCardDetail(this.outFormParam).then(res=>{
                console.log(res)
                if(res.data.status==200){
                    this.cardFormParam = res.data.value
                } else {
                    this.$message({
                        showClose: true,
                        message: res.data.message||'网络异常',
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.log(err)
                this.$message({
                    showClose: true,
                    message: err.message||err.data.message||'网络异常',
                    type: 'error'
                });
            });
        },
        submitOutCardBatch(){
            console.log(this.outFormParam)
            balanceCardOut(this.outFormParam).then(res=>{
                if(res.data.status==200){
                    this.$message({
                        showClose: true,
                        message: res.data.value||'成功',
                        type: 'success'
                    });
                    this.queryGiftCardBatch()
                    this.newOutVisible = false
                } else {
                    this.$message({
                        showClose: true,
                        message: res.data.message||'网络异常',
                        type: 'error'
                    });
                }

            }).catch((err) => {
                console.log(err)
                this.$message({
                    showClose: true,
                    message: err.message||err.data.message||'网络异常',
                    type: 'error'
                });
            });
        }

    }
}
</script>
<style lang="scss">
.balance-card-batch{
    .el-input-number .el-input__inner{
        text-align: left;
    }
    .el-drawer__header{
        margin-bottom: 15px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/card/BalanceCardBatch.vue